
import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';

import "./customicons.css"

export const ProgressIcon = ({isLoading}) => {

  return (
   
    <div>
      {
        (isLoading) &&
          <div className='wait-icon'>
            <CircularProgress style={{ color: 'maroon' }}/>
          </div>
}     
    </div> 

  )
}
  




